<template>
  <div class="operational-dashboard-wrap">
    <woot-loading-state
      v-if="uiFlags.isFetching && !data"
      :message="$t('OPERATIONAL_DASHBOARD.LOADING')"
    />
    <p v-else-if="uiFlags.isError" class="operational-dashboard-error">
      {{ $t('OPERATIONAL_DASHBOARD.ERROR') }}
    </p>
    <div v-else-if="data" class="operational-dashboard">
      <h3 class="operational-dashboard__greeting">
        {{ $t('OPERATIONAL_DASHBOARD.GREETING', { name: agentName }) }}
      </h3>

      <opportunities-summary />

      <div class="operational-dashboard__conversations">
        <p class="operational-dashboard__subtitle">
          {{ $t('OPERATIONAL_DASHBOARD.SUBTITLE') }}
        </p>
        <stat-cards-row
          :mine-conversations="data.mine_conversations"
          :queued-conversations="data.queued_conversations || 0"
          :show-queued-conversations="data.queued_conversations !== null"
          :open-conversations="data.open_conversations"
          :agents-online="agentStatus.online"
          :agents-total="agentStatus.total"
          :show-agents-online="isAgentsOnlineVisible"
        />
      </div>

      <priority-breakdown
        :conversations-by-priority="data.conversations_by_priority"
      />

      <distribution-breakdown
        :conversations-by-team="data.conversations_by_team"
        :conversations-by-inbox="data.conversations_by_inbox"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StatCardsRow from './StatCardsRow.vue';
import PriorityBreakdown from './PriorityBreakdown.vue';
import DistributionBreakdown from './DistributionBreakdown.vue';
import OpportunitiesSummary from './OpportunitiesSummary.vue';

export default {
  name: 'OperationalDashboard',
  components: {
    StatCardsRow,
    PriorityBreakdown,
    DistributionBreakdown,
    OpportunitiesSummary,
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      currentRole: 'getCurrentRole',
      uiFlags: 'operationalDashboard/getUIFlags',
      data: 'operationalDashboard/getData',
      agentStatus: 'agents/getAgentStatus',
    }),
    agentName() {
      return this.currentUser?.name || '';
    },
    isAgentsOnlineVisible() {
      return (
        this.currentUser?.type === 'SuperAdmin' ||
        ['administrator', 'supervisor'].includes(this.currentRole)
      );
    },
  },
  mounted() {
    this.$store.dispatch('operationalDashboard/fetch');
  },
};
</script>

<style lang="scss" scoped>
.operational-dashboard-wrap {
  background: var(--color-background-light);
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding: var(--space-large);
  width: 100%;
}

.operational-dashboard {
  display: flex;
  flex-direction: column;
  gap: var(--space-large);
  height: 100%;
  max-width: 100%;

  &__greeting {
    font-size: var(--font-size-big);
    margin-bottom: 0;
  }

  &__conversations {
    display: flex;
    flex-direction: column;
    gap: var(--space-normal);
  }

  &__subtitle {
    color: var(--s-600);
    font-size: var(--font-size-default);
    margin-bottom: 0;
  }
}

.operational-dashboard-error {
  color: var(--s-600);
  padding: var(--space-normal);
  text-align: center;
}
</style>
